<template>
  <div class="service-record-page">
    <!-- 搜索行 -->
    <div class="search-row">
      <div class="search-box">
        <van-icon name="search" size="20" color="#999" />
        <input
          v-model="searchText"
          class="search-input"
          type="text"
          placeholder="请输入企业或岗位名称"
        />
        <van-icon v-if="searchText" name="clear" size="20" color="#c8c9cc" class="search-clear" @click="clearSearch" />
        <van-button class="search-btn" size="small" round @click="onSearch">搜索</van-button>
      </div>
    </div>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <!-- 服务记录卡片列表（加载更多） -->
      <div class="record-list">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          :immediate-check="false"
          @load="onLoad"
        >
          <div v-for="item in list" :key="item.projectId" class="record-card">
            <!-- 中间：任务信息 -->
            <div class="record-body">
              <div class="task-name">{{ item.projectName }}</div>
              <div class="meta-line">{{ item.merName }}</div>
              <div class="meta-line">服务记录：{{ item.recordCount }}条</div>
            </div>

            <!-- 底部：查看按钮 -->
            <div class="record-footer">
              <van-button class="view-btn" plain type="info" size="small" @click="onView(item)">查看</van-button>
            </div>
          </div>
        </van-list>
      </div>
    </van-pull-refresh>

    <!-- 空状态 -->
    <van-empty description="暂无服务记录" v-if="finished && !list.length" />

    <footer-menu></footer-menu>
  </div>
</template>
<script>
import footerMenu from '@/components/footer/FooterMenu'
import requestHomeAPI from '@/axios/HomeApi'

export default {
  name: 'ServiceRecord',
  components: {
    footerMenu
  },
  data () {
    return {
      refreshing: false,
      // 搜索关键字（服务端检索，传 projectName）
      searchText: '',
      // 列表分页状态
      list: [],
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 10
    }
  },
  created () {
    this.resetList()
  },
  methods: {
    // van-list 触底加载一页
    onLoad () {
      this.loading = true
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      // 搜索关键字作为任务名称传给接口（服务端检索）
      const keyword = this.searchText.trim()
      if (keyword) {
        params.projectName = keyword
      }
      requestHomeAPI.serviceRecordList(params).then(res => {
        if (res.data.code === '0000') {
          const data = res.data.data || {}
          const rows = data.rows || []
          // 追加到列表末尾（加载更多）
          this.list = this.list.concat(rows)
          const total = data.total || 0
          this.pageNum++
          // 结束条件：数据到齐，或本页不足一页（服务端 total 与实际条数不一致时防止无限翻页）
          if (this.list.length >= total || rows.length < this.pageSize) {
            this.finished = true
          }
        } else {
          this.finished = true
          this.$notify({ type: 'danger', message: res.data.message })
        }
      }).catch(() => {
        this.finished = true
        this.$notify({ type: 'danger', message: '加载失败，请重试' })
      }).finally(() => {
        this.loading = false
      })
    },
    // 重置列表并重新加载
    resetList () {
      this.list = []
      this.pageNum = 1
      this.finished = false
      this.onLoad()
    },
    // 下拉刷新：从第一页重新加载
    onRefresh () {
      this.refreshing = false
      this.resetList()
    },
    // 搜索
    onSearch () {
      this.resetList()
    },
    // 清空搜索关键字并加载全部结果
    clearSearch () {
      this.searchText = ''
      this.resetList()
    },
    // 查看服务记录详情
    onView (item) {
      this.$router.push({
        path: '/serviceRecordDetail',
        query: { projectId: item.projectId }
      })
    }
  }
}
</script>
<style scoped lang="less">
/*
 * 注意：项目 postcss 按 750 设计稿宽度将 px 自动转成 vw（src 代码），
 * 即源码数值是设计稿坐标，实际渲染大小 = 数值 ÷ 2。
 */
.service-record-page {
  min-height: 100%;
  background: #f5f5f5;
}

/* 搜索行 */
.search-row {
  padding: 20px 32px;
  background: #fff;

  .search-box {
    display: flex;
    align-items: center;
    height: 96px;
    padding: 0 16px 0 24px;
    background: #f5f5f5;
    border-radius: 999px;

    .search-input {
      flex: 1;
      border: none;
      outline: none;
      background: transparent;
      margin-left: 16px;
      font-size: 30px;
      color: #323233;

      &::placeholder {
        color: #c8c9cc;
      }
    }

    /* 清空搜索图标 */
    .search-clear {
      margin: 0 16px 0 8px;
    }

    .search-btn.van-button {
      flex-shrink: 0;
      height: 80px;
      line-height: 80px;
      padding: 0 40px;
      font-size: 30px;
      border: 1px solid #e92504;
      border-radius: 999px;
      color: #e92504;
    }
  }
}

.record-list {
  padding: 20px;
}

/* 服务记录卡片 */
.record-card {
  padding: 28px 32px;
  background: #fff;
  border-radius: 16px;
  margin-bottom: 20px;
  text-align: left;

  /* 顶部：品牌名 */
  .record-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    .brand-name {
      font-size: 30px;
      font-weight: 600;
      color: #323233;
    }
  }

  /* 中间：任务信息 */
  .record-body {
    .task-name {
      font-size: 34px;
      font-weight: 600;
      color: #323233;
      margin-bottom: 8px;
    }

    .meta-line {
      font-size: 26px;
      color: #999;
      line-height: 40px;
    }
  }

  /* 底部：查看按钮右对齐 */
  .record-footer {
    margin-top: 16px;
    text-align: right;

    .view-btn {
      font-size: 26px;
      height: 60px;
      padding: 0 28px;
      border-radius: 8px;
      border-color: #e92504; /* 红色边框 */
      color: #e92504; /* 红色文字 */
    }
  }
}
</style>
